// Angular
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

// Libraries
import * as objectPath from 'object-path';
import { Observable, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Models
import { AppCleanup } from '../../models';

// Services
import { SplashScreenService } from './services/splash-screen.service';
import { LayoutConfigService } from '../../services/layout-config.service';

// Store
import { StorageState } from '../../state/storage.state';

@Component({
	selector: 'splash-screen',
	templateUrl: './splash-screen.component.html',
	styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent extends AppCleanup implements OnInit, OnDestroy {
	@Select(StorageState.darkMode) darkMode$: Observable<boolean>;
	darkMode: boolean;
	selectedLoaderLogo: string;
	loaderLogoDark: string;
	loaderLogoLight: string;
	loaderType: string;
	loaderMessage: string;
	primaryColor: string;

	@ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private splashScreenService: SplashScreenService
	) {
		super();
	}

	ngOnInit() {
		// Init splash screen, see loader option in layout.config.ts
		this.layoutConfigService.localLayoutConfig$.pipe(takeUntil(this.destroy)).subscribe((layoutConfig) => {
			if (layoutConfig) {
				const loaderConfig = objectPath.get(layoutConfig, 'loader');
				this.loaderLogoDark = objectPath.get(loaderConfig, 'logoDark');
				this.loaderLogoLight = objectPath.get(loaderConfig, 'logoLight');
				this.loaderType = objectPath.get(loaderConfig, 'type');
				this.loaderMessage = objectPath.get(loaderConfig, 'message');
				this.primaryColor = objectPath.get(layoutConfig, 'loader.color');
				this.splashScreenService.init(this.splashScreen);

				this.darkMode$.pipe(takeUntil(this.destroy)).subscribe((darkMode) => {
					this.darkMode = darkMode;

					if (darkMode) {
						this.selectedLoaderLogo = this.loaderLogoLight;
						this.primaryColor = 'white';
					} else {
						this.selectedLoaderLogo = this.loaderLogoDark;
					}

					this.setColor();
				});
			}
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	setColor() {
		let elements = document.querySelectorAll<HTMLElement>('.spinner-dot');
		for (var i = 0; i < elements.length; i++) {
			elements[i].style.backgroundColor = this.primaryColor;
		}
	}
}
